<template>
  <qx-card-form title="申请信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <!-- 车牌号码 -->
      <section slot="car" slot-scope="prop">
        <ChooseCar
          :isRadio="true"
          v-model="prop.form.car"
          @change="handleCarChange"
        />
      </section>
      <!-- 车牌号码 end -->
      <!-- 司机姓名 -->
      <section slot="driver" slot-scope="prop">
        <ChooseDriver
          :isRadio="true"
          v-model="prop.form.driver"
          @change="handleDriverChange"
        />
      </section>
      <!-- 司机姓名 end -->
      <!-- 订单号码 -->
      <section slot="order" slot-scope="prop">
        <ChooseOrder
          slot="order"
          :isRadio="true"
          v-model="prop.form.order"
          :otherSearchData="chooseOrderSearchData"
          :disabled="chooseOrderDisabled"
          placeholder="选择车牌后可选择订单号"
        />
      </section>
      <!-- 订单号码 end -->
      <!-- 维修站点 -->
      <section slot="site" slot-scope="prop">
        <ChooseSite
          :isRadio="true"
          v-model="prop.form.site"
          @change="handleSiteChange"
        />
      </section>
      <!-- 维修站点 end -->
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  getEnumList,
  getDepartmentAllList,
} from 'api';
import {
  mapState,
} from 'vuex';
import ChooseCar from 'components/choose/car';
import ChooseDriver from 'components/choose/driver';
import ChooseSite from 'components/choose/site';
import ChooseOrder from 'components/choose/order';
export default {
  components: {
    ChooseCar,
    ChooseDriver,
    ChooseSite,
    ChooseOrder,
  },
  data () {
    return {
      chooseOrderDisabled: true,
      chooseCarInfo: {},
      chooseOrderSearchData: {},
      baseForm: {
        applyTypeOptions: [], // 费用类型
        stateOptions: [], // 维保状态
        orgIdOptions: [], // 费用归属
        form: [
          {
            label: '费用类型',
            value: 'applyType',
            type: 'select',
          },
          {
            label: '费用归属',
            value: 'orgId',
            type: 'select',
            disabled: true,
          },
          {
            label: '预估费用',
            value: 'preAmt',
            type: 'input',
          },
          {
            label: '车牌号码',
            value: 'car',
            default: {},
            slot: true,
          },
          {
            label: '司机姓名',
            value: 'driver',
            default: {},
            slot: true,
          },
          {
            label: '司机手机',
            value: 'loginAcct',
            type: 'input',
            disabled: true,
          },
          {
            label: '订单号码',
            value: 'order',
            default: {},
            slot: true,
          },
          {
            label: '维修站点',
            value: 'site',
            default: {},
            slot: true,
          },
          {
            label: '服务商',
            value: 'serviceName',
            type: 'input',
            disabled: true,
          },
          {
            label: '费用归属日期',
            value: 'feeAscriptionDate',
            type: 'date',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '受损图片',
            value: 'beforePicFile',
            type: 'img',
            accept: 'image/*',
            default: [],
          },
          {
            label: '申请原因',
            value: 'repairReson',
            type: 'input',
            attr: {
              type: 'textarea',
            },
          },
          {
            label: '费用说明',
            value: 'amtRemark',
            type: 'input',
            attr: {
              type: 'textarea',
            },
          },
        ],
        rules: {
          applyType: [ // 费用类型
            { required: true, message: '请选择费用类型', trigger: 'blur' },
          ],
          orgId: [ // 费用归属
            { required: true, message: '请选择费用归属', trigger: 'blur' },
          ],
          preAmt: [ // 预估费用
            { required: true, message: '请输入预估费用', trigger: 'blur' },
          ],
          car: [ // 车牌号码
            { required: true, message: '请选择车牌号码', trigger: 'blur' },
          ],
          driver: [ // 司机姓名
            { required: true, message: '请选择司机姓名', trigger: 'blur' },
          ],
          loginAcct: [ // 司机手机
            { required: true, message: '请输入司机手机', trigger: 'blur' },
          ],
          site: [ // 维修站点
            { required: true, message: '请选择维修站点', trigger: 'blur' },
          ],
          serviceName: [ // 服务商
            { required: true, message: '请选择服务商', trigger: 'blur' },
          ],
          feeAscriptionDate: [ // 费用归属日期
            { required: true, message: '请选择费用归属日期', trigger: 'blur' },
          ],
          repairReson: [ // 申请原因
            { required: true, message: '请输入申请原因', trigger: 'blur' },
          ],
          amtRemark: [ // 费用说明
            { required: true, message: '请输入费用说明', trigger: 'blur' },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {

    handleCarChange () {
      const car = this.$refs.baseForm.getVal('car');
      if (car.plateNumber) {
        this.chooseCarInfo = car;
        this.chooseOrderDisabled = false;

        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const date = `${currentDate.getDate()}`.padStart(2, '0');
        const hour = `${currentDate.getHours()}`.padStart(2, '0');
        const min = `${currentDate.getMinutes()}`.padStart(2, '0');
        const sec = `${currentDate.getSeconds()}`.padStart(2, '0');

        const lastMonth = `${currentDate.getMonth()}`.padStart(2, '0');
        const startDependTime = `${year}-${lastMonth}-01 00:00:00`;

        const currentMonth = `${currentDate.getMonth() + 1}`.padStart(2, '0');
        const endDependTime = `${year}-${currentMonth}-${date} ${hour}:${min}:${sec}`;

        this.chooseOrderSearchData = {
          filtrationExpense: -1,
          orgId: car.orgId,
          plateNumber: car.plateNumber,
          // 上个月1号 YYYY-MM-DD 00:00:00
          startDependTime,
          // 当前时间 YYYY-MM-DD HH:mm:ss
          endDependTime,
        };
      } else {
        this.chooseOrderDisabled = true;
      }
    },

    handleDriverChange () {
      const driver = this.$refs.baseForm.getVal('driver');
      this.$refs.baseForm.setVal('loginAcct', driver.loginAcct);
    },

    handleSiteChange () {
      const site = this.$refs.baseForm.getVal('site');
      this.$refs.baseForm.setVal('serviceName', site.serviceName);
    },

    async getList () {
      this.baseForm.orgIdOptions = await getDepartmentAllList();
      const enumsList = await getEnumList({
        codeType: 'REPAIR_APPLY_TYPE,REPAIR_APPLY_STATE',
      });
      this.baseForm.applyTypeOptions = enumsList[0]; // 费用类型
      this.baseForm.stateOptions = enumsList[1]; // 维保状态
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // 车牌号码
        formData.plateNumber = formData.car.plateNumber;
        formData.vehicleCode = formData.car.vehicleCode;
        formData.licenceType = formData.car.licenceType;
        delete formData.car;
        // 司机姓名
        formData.userName = formData.driver.linkman;
        formData.userId = formData.driver.userId;
        delete formData.driver;
        // 订单号码
        formData.orderId = formData.order.orderId;
        delete formData.order;
        // 维修站点
        formData.serviceId = formData.site.serviceUserId;
        formData.productName = formData.site.productName;
        formData.productId = formData.site.productId;
        delete formData.site;
        // 费用归属日期
        formData.feeAscriptionDate = this.formatDate(formData.feeAscriptionDate, 1);

        formData.chooseOrderDisabled = this.chooseOrderDisabled;
      }
      return formData;
    },

    async sub () {
      const formData = await this.handleSubData();
      if (formData.beforePicFile) {
        formData.beforePicFileIds = formData.beforePicFile.map((item) => item.id);
        formData.beforePicFileIds = formData.beforePicFileIds.join(',');
      }
      delete formData.beforePicFile;
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    init (data = {}) {
      if (!data.orgId) {
        for (let i = 0; i < this.baseForm.orgIdOptions.length; i++) {
          if (this.baseForm.orgIdOptions[i].label === this.userInfo.tenantName) {
            data.orgId = this.baseForm.orgIdOptions[i].value;
            break;
          }
        }
      }
      if (data.costDetails) {
        data = {
          ...data,
          ...data.costDetails[0],
        };
      }
      // 费用类型
      if (data.applyType !== undefined && data.applyType !== null) {
        data.applyType = String(data.applyType);
      }
      // 车牌号码
      data.car = {
        plateNumber: data.plateNumber,
        vehicleCode: data.vehicleCode,
        licenceType: data.licenceType,
      };
      data.loginAcct = data.loginAcct || data.mobilePhone;
      // 司机姓名
      data.driver = {
        linkman: data.userName,
        userId: data.userId,
      };
      // 订单号码
      data.order = {
        orderId: data.orderId,
      };
      // 维修站点
      data.site = {
        serviceUserId: data.serviceId,
        productName: data.productName,
        productId: data.productId,
      };
      if (!data.beforePicFile && data.beforePicList) {
        data.beforePicFile = data.beforePicList.map((item) => ({
          id: item.fileId || item.id,
          url: item.fileUrl || item.url,
        }));
      }
      this.$refs.baseForm.setVal('form', data);
      this.handleCarChange();
    },
  },
};
</script>

<style scoped lang="scss">
</style>
